import React, { useState } from 'react';
import cameraIconImg from 'images/camera_icon.png';
import StepFooter from 'components/presenters/footer/StepFooter';

import {
  Terminner,
  Maintit2,
  Subtit,
  Subcont,
  Fileinput,
  Filelabel,
  Fileimg,
  Pictureinner,
  PreviewInner,
  Preview,
  PreviewImg,
  PreviewImglist,
} from './style';

export default function ProjectSettingSampleProofStep({
  updateNext,
  dataSubmit,
  images,
  setImages,
}) {
  // const [next ,setNext] = useState(false);
  const [imagesist, setImageslist] = useState([]);
  const imagesChange = (e) => {
    let newImageList = [];
    for (const [key, value] of Object.entries(e.target.files)) {
      newImageList.push(value);
    }
    newImageList = imagesist.concat(newImageList);
    setImages(newImageList);
    setImageslist(newImageList);
  };

  return (
    <Terminner>
      <Pictureinner>
        <Maintit2>
          인증샷 예시 <Subtit>&#40;선택 사항&#41;</Subtit>{' '}
        </Maintit2>
        <Subcont>
          정확한 인증샷 기준일 수록, 멤버들의 분쟁의 소지가 적어집니다. <br />
          분쟁에 대해서는 Fitner가 관여하지 않습니다. <br />
        </Subcont>

        <PreviewInner>
          {images ? (
            <PreviewImglist>
              {imagesist
                ? imagesist.map((value, index) => {
                    let image = URL.createObjectURL(value);
                    return (
                      <Preview key={`update-sample-proof-preview-${index}`}>
                        {' '}
                        <PreviewImg src={image}></PreviewImg>
                      </Preview>
                    );
                  })
                : null}
              <Fileinput
                type="file"
                id="filepic"
                multiple={true}
                onChange={imagesChange}
              ></Fileinput>
              <Filelabel htmlFor="filepic">
                <Fileimg>
                  <img src={cameraIconImg}></img>
                </Fileimg>
              </Filelabel>
            </PreviewImglist>
          ) : (
            <>
              <Fileinput
                type="file"
                id="filepic"
                multiple={true}
                onChange={imagesChange}
              ></Fileinput>
              <Filelabel htmlFor="filepic">
                <Fileimg>
                  <img src={cameraIconImg}></img>
                </Fileimg>
              </Filelabel>
            </>
          )}
        </PreviewInner>
      </Pictureinner>

      <StepFooter
        text={'프로젝트 만들기'}
        position={'fixed'}
        prevdisplay={'flex'}
        updateNext={updateNext}
        textClick={dataSubmit}
      />
    </Terminner>
  );
}
